module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editable-td"
  }, [(!_vm.isEditMode) ? _c('div', {
    staticClass: "editable-td__value",
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
        return _vm.onDoubleClick.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.editValue) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
    staticClass: "editable-td__input-holder",
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editValue),
      expression: "editValue"
    }],
    staticClass: "editable-td__input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editValue = $event.target.value
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-968750d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditableTD.vue
// module id = 251
// module chunks = 1